import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "dia" }
const _hoisted_2 = {
  key: 0,
  class: "interno quanto loading"
}
const _hoisted_3 = {
  key: 1,
  class: "interno quanto zero"
}
const _hoisted_4 = {
  key: 2,
  class: "interno quanto warn"
}
const _hoisted_5 = {
  key: 3,
  class: "interno"
}
const _hoisted_6 = { class: "quanto" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["kennel-count-internal", {error:($setup.count && $setup.count < 0), loading:($setup.count === null)}]),
    style: _normalizeStyle(`background-color:${$setup.color}; --square-color:${$setup.color2};`)
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createTextVNode(_toDisplayString($props.day), 1),
      ($setup.count === null)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, "..."))
        : ($setup.count === 0)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[0] || (_cache[0] = [
              _createElementVNode("svg", {
                class: "icon close",
                xmlns: "http://www.w3.org/2000/svg",
                viewBox: "0 0 24 24"
              }, [
                _createElementVNode("path", {
                  class: "fill",
                  d: "M19 6.41L17.59 5L12 10.59L6.41 5L5 6.41L10.59 12L5 17.59L6.41 19L12 13.41L17.59 19L19 17.59L13.41 12L19 6.41Z"
                })
              ], -1)
            ])))
          : ($setup.count < 0)
            ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString($setup.count), 1))
            : (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, _toDisplayString($setup.count), 1),
                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "txt" }, "available", -1))
              ]))
    ])
  ], 6))
}